import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { CommentsComponent } from 'app/assessment/questions/comments/comments.component';
import { DiscomfortBodyDiagramComponent } from 'app/assessment/questions/discomfort-body-diagram/discomfort-body-diagram.component';
import { DiscomfortDetailsComponent } from 'app/assessment/questions/discomfort-details/discomfort-details.component';
import { DynamicQuestionContentComponent } from 'app/assessment/questions/dynamic-question-content/dynamic-question-content.component';
import { ErgonomicRecommendationsComponent } from 'app/assessment/questions/ergonomic-recommendations/ergonomic-recommendations.component';
import { ExecutiveSummaryComponent } from 'app/assessment/questions/executive-summary/executive-summary.component';
import { MultiTextInputComponent } from 'app/assessment/questions/multi-text-input/multi-text-input.component';
import { RadioCheckboxGroupComponent } from 'app/assessment/questions/radio-checkbox-group/radio-checkbox-group.component';
import { TextInputComponent } from 'app/assessment/questions/text-input/text-input.component';
import { UnknownQuestionGroupComponent } from 'app/assessment/questions/unknown-question-group/unknown-question-group.component';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';

import { EditEvaluationRecommendationComponent } from './ergonomic-recommendations/edit-evaluation-recommendation/edit-evaluation-recommendation.component';

@NgModule({
  imports: [
    MaterialModule,
    CommonModule,
    ReactiveFormsModule,
    EditorModule,
    SharedModule,
    TranslateModule,
  ],
  declarations: [
    RadioCheckboxGroupComponent,
    DiscomfortBodyDiagramComponent,
    DynamicQuestionContentComponent,
    UnknownQuestionGroupComponent,
    ExecutiveSummaryComponent,
    CommentsComponent,
    DiscomfortDetailsComponent,
    ErgonomicRecommendationsComponent,
    TextInputComponent,
    MultiTextInputComponent,
    EditEvaluationRecommendationComponent,
  ],
  exports: [
    RadioCheckboxGroupComponent,
    DiscomfortBodyDiagramComponent,
    DynamicQuestionContentComponent,
    UnknownQuestionGroupComponent,
    ExecutiveSummaryComponent,
    CommentsComponent,
    DiscomfortDetailsComponent,
    ErgonomicRecommendationsComponent,
    TextInputComponent,
    MultiTextInputComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
  entryComponents: [
    // any component that could be dynamically injected needs to be in this array
    RadioCheckboxGroupComponent,
    UnknownQuestionGroupComponent,
    ExecutiveSummaryComponent,
    CommentsComponent,
    DiscomfortDetailsComponent,
    ErgonomicRecommendationsComponent,
    TextInputComponent,
    MultiTextInputComponent,
  ],
})
export class QuestionsModule { }
